const IMAGE_LOADING_PREFIX = 'IMAGE_LOADING_';
export const REGISTER_IMAGE_LOADING_ITEM = `${IMAGE_LOADING_PREFIX}_REGISTER_IMAGE_LOADING_ITEM`;
export const registerImageLoadingItemAction = () => ({
  type: REGISTER_IMAGE_LOADING_ITEM
});
export const LOADED_IMAGE_LOADING_ITEM = `${IMAGE_LOADING_PREFIX}_LOADED_IMAGE_LOADING_ITEM`;
export const loadedImageLoadingItemAction = () => ({
  type: LOADED_IMAGE_LOADING_ITEM
});